<div class="d-none event-bar d-md-flex align-items-center ps-md-5 pe-md-5 ps-3 pe-3">
  <span>{{ event?.type }}</span>
  <div class="d-flex grid-gap-05rem">
    <fa-icon icon="calendar"></fa-icon>
    {{ event?.datetime | date:'dd/MM/yyyy' }}
  </div>

  <span class="fw-bold">{{ event?.title }}</span>
  <span>{{ event?.description }}</span>

  <a [href]="event?.link" target="_blank">{{ event?.linktitle }}</a>
</div>

<div class="d-flex justify-content-between event-bar d-md-none align-items-center ps-md-5 pe-md-5 ps-3 pe-3">
  <div class="d-flex grid-gap-05rem">
    <fa-icon icon="bullhorn"></fa-icon>
    <span class="fw-bold">{{ event?.title }}</span>
  </div>
  <span class="cursor-pointer text-decoration-underline" (click)="seeDetail()">Voir</span>
</div>


<ng-template #eventmodal let-modal>
  <div class="modal-header border-bottom-0 pb-0">
    <h1 class="modal-title" id="modal-basic-title-reject">
      {{ event?.title }}
    </h1>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()">
    </button>
  </div>
  <div class="modal-body pt-2">
    <h2>
      <fa-icon icon="calendar"></fa-icon>
      {{ event?.datetime | date:'dd/MM/yyyy' }}
    </h2>
    <h2 class="pt-1">{{ event?.type }}</h2>
    <h4 class="pt-1 line-height-2">
      {{ event?.description }}
    </h4>
  </div>
  <div class="modal-footer border-top-0 d-flex justify-content-between">
    <app-cancel-button (click)="modal.dismiss()"></app-cancel-button>
    <a type="button" class="btn btn-primary" [href]="event?.link" target="_blank">{{ event?.linktitle }}</a>
  </div>
</ng-template>
